{
  "admission": "入院",
  "transfer": "转科",
  "visit": "就诊",
  "type": "就诊类型",
  "status": "状态",
  "location": "科室位置",
  "attendingPhysician": "主治医生",
  "admitDate": "入院日期",
  "dischargeDate": "出院日期",
  "chiefComplaint": "主诉",
  "diagnosis": "诊断",
  "class": {
    "label": "类别",
    "values": {
      "emergency": "急诊",
      "inpatient": "住院",
      "outpatient": "门诊",
      "observation": "留观",
      "ambulatory": "日间诊疗",
      "homeHealth": "居家医疗",
      "virtual": "远程医疗"
    }
  },
  "statusValues": {
    "label": "状态",
    "values": {
      "pending": "待处理",
      "arrived": "已到达",
      "active": "进行中",
      "completed": "已完成",
      "cancelled": "已取消"
    }
  },
  "admissionSource": {
    "label": "入院来源",
    "none": "—",
    "values": {
      "emergency": "急诊科",
      "clinicReferral": "门诊转入",
      "physicianReferral": "医师转介",
      "transfer": "他院转入",
      "self": "自行就诊 / 步入",
      "courtLaw": "司法 / 公安机关"
    }
  },
  "admissionType": {
    "label": "入院类型",
    "none": "—",
    "values": {
      "elective": "择期",
      "emergency": "急诊",
      "urgent": "紧急",
      "newborn": "新生儿",
      "trauma": "创伤"
    }
  },
  "acuity": {
    "label": "病情等级",
    "none": "—",
    "values": {
      "1": "1 — 复苏",
      "2": "2 — 危重",
      "3": "3 — 紧急",
      "4": "4 — 次紧急",
      "5": "5 — 非紧急"
    },
    "shortValues": {
      "1": "复苏",
      "2": "危重",
      "3": "紧急",
      "4": "次紧急",
      "5": "非紧急"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "新建就诊",
    "subtitle": "为该患者开始新的就诊 / 入院。",
    "sections": {
      "visit": "就诊信息",
      "reasonForVisit": "就诊原因",
      "admission": "入院信息"
    },
    "fields": {
      "facility": "院区",
      "encounterClass": "就诊类别",
      "encounterType": "就诊类型",
      "department": "科室",
      "attendingProvider": "主治医生",
      "acuity": "病情等级",
      "visitReason": "就诊原因",
      "chiefComplaint": "主诉",
      "admissionSource": "入院来源",
      "admissionType": "入院类型"
    },
    "placeholders": {
      "selectFacility": "选择院区",
      "none": "—",
      "encounterType": "例如:年度体检、急诊就诊",
      "visitReason": "简短标签,例如:复诊、年度体检",
      "chiefComplaint": "患者用自己的话陈述的原因"
    },
    "providerFallback": "医生 #{{id}}",
    "submit": "创建就诊",
    "validation": {
      "facilityRequired": "请选择院区",
      "encounterClassRequired": "请选择就诊类别"
    },
    "createdSuccess": "就诊已创建",
    "createError": "创建就诊失败"
  },
  "detail": {
    "loading": "正在加载就诊信息...",
    "notFound": "未找到该就诊",
    "loadError": "加载就诊失败",
    "retry": "重试",
    "returnToDashboard": "返回工作台",
    "header": {
      "title": "就诊 {{number}}",
      "facilityLabel": "院区 #{{id}}",
      "departmentLabel": "科室 #{{id}}",
      "locationLabel": "位置 #{{id}}",
      "admittedLabel": "入院时间:{{datetime}}"
    },
    "actions": {
      "transfer": "转科",
      "discharge": "出院"
    },
    "tabs": {
      "overview": "概览",
      "orders": "医嘱",
      "results": "检验结果",
      "medications": "用药",
      "notes": "病历",
      "billing": "费用"
    },
    "overview": {
      "chiefComplaint": "主诉",
      "visitReason": "就诊原因",
      "attendingProvider": "主治医生",
      "acuityLevel": "病情等级",
      "providerFallback": "医生 #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "事件时间线",
      "empty": "暂无事件记录",
      "admittedTitle": "入院",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "无主诉",
      "orderTitle": "医嘱:{{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "结果:{{type}}"
    },
    "orders": {
      "title": "医嘱",
      "newOrder": "+ 新建医嘱",
      "empty": "本次就诊暂无医嘱",
      "metaLine": "{{number}} | {{type}} | 优先级:{{priority}}"
    },
    "results": {
      "title": "检验结果",
      "empty": "本次就诊暂无结果",
      "criticalBadge": "危急",
      "viewLink": "查看",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "用药",
      "newMedication": "+ 新建用药",
      "empty": "本次就诊暂无用药",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN:{{indication}}"
    },
    "notes": {
      "comingSoon": "病历模块即将上线",
      "goToClinicalNotes": "前往临床病历"
    },
    "billing": {
      "comingSoon": "费用模块即将上线"
    }
  },
  "census": {
    "title": "床位看板 / 在院列表",
    "subtitle": "实时床位占用与患者在院情况",
    "refresh": "刷新",
    "facilityName": "新加坡中央医院",
    "capacitySummary": "在用 {{occupied}} / 共 {{total}} 张床位",
    "occupancyLabel": "占用率 {{percent}}%",
    "stats": {
      "totalCapacity": "床位总数",
      "occupied": "已占用",
      "available": "可用",
      "pendingDischarge": "待出院"
    },
    "unitFilter": {
      "all": "全部病区",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "内外科",
      "obs": "观察室",
      "peds": "儿科",
      "maternity": "产科"
    },
    "roleView": {
      "nurse": "护士视图",
      "physician": "医生视图",
      "bedManager": "床位管理视图"
    },
    "viewMode": {
      "grid": "网格视图",
      "table": "表格视图"
    },
    "loading": "正在加载在院数据...",
    "columns": {
      "patient": "患者",
      "mrn": "MRN",
      "admitDate": "入院日期",
      "status": "状态",
      "acuity": "病情等级",
      "isolation": "隔离",
      "fallRisk": "跌倒风险",
      "codeStatus": "抢救等级",
      "chiefComplaint": "主诉",
      "attending": "主治",
      "los": "LOS",
      "locationBed": "位置 / 床位",
      "transferStatus": "转科状态",
      "expectedDischarge": "预计出院",
      "actions": "操作"
    },
    "values": {
      "unknownPatient": "未知",
      "none": "无",
      "notAvailable": "N/A",
      "pending": "待处理",
      "empty": "--",
      "providerFallback": "医生 #{{id}}",
      "locationLabel": "位置 #{{id}}",
      "losDays": "{{days}}天"
    },
    "codeStatusTooltip": "抢救等级请见患者档案",
    "actionsMenu": {
      "label": "操作",
      "viewChart": "查看档案",
      "transfer": "转科",
      "assignAttending": "分配主治医生",
      "discharge": "出院"
    },
    "empty": "暂无在院就诊",
    "department": {
      "filteredTo": "仅显示 {{name}}",
      "idLabel": "科室 {{id}}",
      "showAll": "显示所有科室"
    },
    "facility": {
      "label": "机构",
      "allFacilities": "全部机构",
      "idLabel": "机构 {{id}}"
    }
  },
  "discharge": {
    "label": "出院",
    "title": "出院流程",
    "encounterLabel": "就诊 {{number}}",
    "printButton": "打印出院记录",
    "loading": "正在加载就诊信息...",
    "notFound": "未找到该就诊",
    "returnToDashboard": "返回工作台",
    "notActive": "该就诊未处于进行中状态(当前状态:{{status}})",
    "backToEncounter": "返回就诊页",
    "progress": {
      "requiredMissingTooltip": "必填项未填写",
      "tasksRemainingTooltip": "尚有任务未完成"
    },
    "steps": {
      "summary": "出院小结",
      "medications": "用药",
      "followup": "随访",
      "instructions": "出院指导",
      "nursing": "护理任务",
      "signoff": "主治医师签字",
      "review": "复核与确认"
    },
    "summary": {
      "title": "出院小结",
      "diagnosisLabel": "出院诊断 *",
      "diagnosisPlaceholder": "请输入出院诊断...",
      "diagnosisCodeLabel": "出院诊断编码(ICD-10)",
      "diagnosisCodePlaceholder": "搜索 ICD-10 编码...",
      "proceduresLabel": "已实施的操作",
      "proceduresPlaceholder": "列出本次就诊期间实施的操作...",
      "conditionLabel": "出院时病情 *"
    },
    "condition": {
      "values": {
        "stable": "平稳",
        "improved": "好转",
        "unchanged": "无变化",
        "worsened": "加重",
        "critical": "危重"
      }
    },
    "medications": {
      "title": "出院带药",
      "instructions": "请逐一审核每种药物,决定继续、停用或调整。",
      "actions": {
        "continue": "继续",
        "stop": "停用",
        "modify": "调整"
      },
      "modifiedPlaceholder": "请输入调整后的用药说明...",
      "empty": "本次就诊暂无在用药物"
    },
    "medAction": {
      "values": {
        "continue": "继续",
        "stop": "停用",
        "modify": "调整"
      }
    },
    "followup": {
      "title": "随访预约",
      "providerLabel": "随访医生",
      "providerPlaceholder": "医生姓名或专科...",
      "dateLabel": "随访日期",
      "notesLabel": "其他备注",
      "notesPlaceholder": "其他随访备注..."
    },
    "instructions": {
      "title": "患者出院指导",
      "generalLabel": "一般指导",
      "generalPlaceholder": "面向患者的一般出院指导...",
      "dietaryLabel": "饮食指导",
      "dietaryPlaceholder": "饮食限制或建议...",
      "activityLabel": "活动限制",
      "activityPlaceholder": "身体活动限制...",
      "warningSignsLabel": "需警惕的症状",
      "warningSignsPlaceholder": "出现这些症状时患者应及时复诊或就医..."
    },
    "nursing": {
      "title": "护理任务",
      "instructions": "出院前请完成以下清单。这些任务仅作记录,不会调用接口。",
      "tasks": {
        "removeIv": "拔除 IV 通路",
        "discontinueMonitoring": "撤除监护设备",
        "patientEducation": "完成患者宣教",
        "medsReviewed": "已与患者核对出院带药",
        "belongingsReturned": "归还个人物品",
        "transportArranged": "已安排离院交通"
      }
    },
    "signoff": {
      "title": "主治医师签字",
      "instructions": "请审阅下方出院小结后,完成主治医师签字。",
      "diagnosisHeading": "出院诊断",
      "notProvided": "未填写",
      "medicationsHeading": "出院带药",
      "noMedications": "无需药物核对",
      "signedCompleted": "主治医师签字已完成。",
      "signAsAttending": "以主治医师身份签字",
      "requiresAttendingSignoff": "需要主治医师签字确认"
    },
    "review": {
      "title": "复核与确认出院",
      "summaryHeading": "出院小结",
      "fields": {
        "diagnosis": "诊断:",
        "procedures": "操作:",
        "condition": "病情:",
        "provider": "医生:",
        "date": "日期:",
        "notes": "备注:",
        "general": "一般:",
        "diet": "饮食:",
        "activity": "活动:",
        "warningSigns": "警惕症状:"
      },
      "medicationsHeading": "药物核对",
      "noMedications": "无需药物核对",
      "followupHeading": "随访",
      "instructionsHeading": "出院指导",
      "noInstructions": "未填写出院指导",
      "pendingOrdersWarning": "可能仍有未完成医嘱或未签字病历,请在完成出院前确认。",
      "diagnosisRequired": "完成出院前必须填写出院诊断。",
      "empty": "--"
    },
    "nav": {
      "previous": "上一步",
      "next": "下一步",
      "complete": "完成出院"
    },
    "toast": {
      "success": "患者已成功出院",
      "error": "完成出院失败"
    }
  },
  "components": {
    "transferDialog": {
      "title": "转移就诊",
      "description": "将患者转移到本机构内的其他位置。",
      "targetLocationLabel": "目标位置",
      "loadingLocations": "正在加载位置…",
      "selectLocation": "请选择位置",
      "emptyState": "本机构内没有其他活动位置。",
      "reasonLabel": "原因",
      "reasonPlaceholder": "例如：需隔离、ICU降级、需要更高监护级别床位",
      "actions": {
        "transfer": "转移"
      },
      "toasts": {
        "success": "就诊已转移",
        "error": "转移就诊失败"
      }
    },
    "assignAttendingDialog": {
      "title": "分配主治医生",
      "description": "设置负责此次就诊的主治医生。",
      "providerLabel": "主治医生",
      "loadingProviders": "正在加载医生…",
      "selectProvider": "选择医生",
      "emptyState": "该机构暂无在职医生。",
      "actions": {
        "assign": "分配"
      },
      "toasts": {
        "success": "主治医生已分配",
        "error": "无法分配主治医生"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "可用",
        "occupied": "占用",
        "reserved": "预留",
        "cleaning": "清洁中",
        "closed": "关闭",
        "isolated": "隔离",
        "contaminated": "已污染"
      },
      "acuityLegendLabel": "ESI 急诊分级：",
      "empty": "未配置病区",
      "summary": {
        "available_one": "{{count}} 可用",
        "available_other": "{{count}} 可用",
        "occupied_one": "{{count}} 占用",
        "occupied_other": "{{count}} 占用",
        "reserved_one": "{{count}} 预留",
        "reserved_other": "{{count}} 预留",
        "cleaning_one": "{{count}} 清洁中",
        "cleaning_other": "{{count}} 清洁中",
        "closed_one": "{{count}} 关闭",
        "closed_other": "{{count}} 关闭",
        "isolated_one": "{{count}} 隔离",
        "isolated_other": "{{count}} 隔离",
        "contaminated_one": "{{count}} 已污染",
        "contaminated_other": "{{count}} 已污染"
      }
    },
    "protocolPanel": {
      "title": "方案登记",
      "enroll": "登记",
      "availableProtocols": "可用方案",
      "loadingProtocols": "正在加载方案...",
      "noProtocols": "暂无可用方案",
      "stepBadge": "步骤 {{current}}/{{total}}",
      "loadingEnrollments": "正在加载登记...",
      "noEnrollments": "暂无有效的方案登记",
      "completeStep": "完成步骤",
      "toasts": {
        "enrollSuccess": "已登记方案",
        "enrollError": "方案登记失败",
        "advanceSuccess": "步骤已完成",
        "advanceError": "步骤推进失败"
      }
    }
  }
}
